import React from 'react';
import { TermsAndConditions as PactSafeTermsAndConditions } from '@fff-web/fff-payments';
import { useUserContext } from '@fff-web/fff-utilities';
import { Disclaimer, DISCLAIMER_NAMES } from '@fff-web/cms';
import { useFeatureFlagContext } from '@fff-web/feature-flags';
import { appEnv } from '../../../utils/env';
import styles from './TermsAndConditions.module.scss';

export const SHIPPING_DISCLAIMER = `*Free shipping only applicable in the contiguous US.
  'Foreign exchange or transaction fees may apply for non US customers.`;

const TermsAndConditions = () => {
  const { userInfo } = useUserContext();
  const { disclaimerPriceIncrease } = useFeatureFlagContext();
  const { reactivateMyMembership, reactivateMyMembershipPriceIncrease } =
    DISCLAIMER_NAMES;
  const disclaimerName = disclaimerPriceIncrease
    ? reactivateMyMembershipPriceIncrease
    : reactivateMyMembership;

  return (
    <div className={styles.termsAndConditionsWrapper}>
      <p
        className={styles.shippingDisclaimer}
        data-testid="shipping-disclaimer"
      >
        {SHIPPING_DISCLAIMER}
      </p>
      <div
        className={styles.disclaimer}
        data-testid={`${disclaimerName}-disclaimer`}
      >
        <Disclaimer name={disclaimerName} env={appEnv} />
      </div>
    </div>
  );
};

export default TermsAndConditions;
